import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import BOMProjectRepository from "../../../repository/BOMProjectRepository";
import BOMProject from "../../../model/BOMProject";
import {__remove, __set} from "../../axios_indicator";

const initialState = {
    total_bom: 0,
    bomProjectList: {},
    yourBomListing: {},
    yourBomListingWithProject: {},
    downloadLoader:false
};

export const fetch_project_list = createAsyncThunk('bom_project_list', async () => {
    __set('BOM_API_CALL');
    return new BOMProject().toObjectWithBOMProjectID(
        await new BOMProjectRepository().listProject()
    );
});

export const fetch_bom_project_detail_with_bom = createAsyncThunk('bom_project_detail_with_bom', async () => {
    __set('BOM_PROJECT_API_CALL');
    return await new BOMProjectRepository().listProjectDetailWithBOM();
});

export const create_project = createAsyncThunk('bom_project_create', async (params) => {
    __set('BOM_PROJECT_OPERATION_API_CALL');
    if (params.bomId !== undefined && params.bomId) {
        return await new BOMProjectRepository().createProject(params.projectName, params.bomId)
    }
    return await new BOMProjectRepository().createProject(params.projectName)
});

export const edit_project = createAsyncThunk('bom_project_edit', async (params) => {
    __set('BOM_PROJECT_OPERATION_API_CALL');
    return await new BOMProjectRepository().editProject(params.projectName, params.projectId)
});

export const fetch_single_project = createAsyncThunk('bom_project_edit', async (params) => {
    __set('BOM_PROJECT_API_CALL');
    return await new BOMProjectRepository().fetchSingleProject(params.projectId)
});

export const delete_project = createAsyncThunk('bom_project_delete', async (params) => {
    __set('BOM_PROJECT_OPERATION_API_CALL');
    return await new BOMProjectRepository().deleteSingleProject(params.projectId)
});

const slice = createSlice({
    name: "BOMProject",
    initialState: initialState,
    reducers:{
        SET_DOWNLOAD_LOADER: {
            reducer: (state, action) => {
                if(state.yourBomListing && Object.entries(state.yourBomListing).length > 0 && !action.payload.projectId)
                {
                    if(state.yourBomListing[action.payload.bomId])
                    {
                        state.yourBomListing[action.payload.bomId].isDownloadLoad = action.payload.isLoad
                    }
                }
                if(state.bomProjectList && Object.entries(state.bomProjectList).length > 0 && action.payload.projectId!=='')
                {
                    if(state.bomProjectList[action.payload.projectId])
                    {
                        if(state.bomProjectList[action.payload.projectId]['bom_listing'][action.payload.bomId])
                        {
                            state.bomProjectList[action.payload.projectId]['bom_listing'][action.payload.bomId].isDownloadLoad = action.payload.isLoad
                        }
                    }
                }
            },
        }
    },
    extraReducers: {
        [fetch_project_list.fulfilled]: (state, {payload}) => {
            __remove('BOM_API_CALL');
            state.bomProjectList = payload.bomProjectList;
            return state;
        },
        [fetch_project_list.rejected]: (state, {payload}) => {
            __remove('BOM_API_CALL');
            return state;
        },
        [fetch_bom_project_detail_with_bom.fulfilled]: (state, {payload}) => {
            __remove('BOM_PROJECT_API_CALL');
            state.total_bom = payload.total_bom;
            state.bomProjectList = payload.project_listing;
            state.yourBomListing = payload.your_bom_listing;
            state.yourBomListingWithProject = payload.your_bom_listing_with_project;
            return state;
        },
        [fetch_bom_project_detail_with_bom.rejected]: (state, {payload}) => {
            __remove('BOM_PROJECT_API_CALL');
        },
        [create_project.fulfilled]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
        [create_project.rejected]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
        [edit_project.fulfilled]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
        [edit_project.rejected]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
        [fetch_single_project.fulfilled]: (state, {payload}) => {
            __remove('BOM_PROJECT_API_CALL');
        },
        [fetch_single_project.rejected]: (state, {payload}) => {
            __remove('BOM_PROJECT_API_CALL');
        },
        [delete_project.fulfilled]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
        [delete_project.rejected]: (state, {payload}) => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        },
    },
});

export let {
    SET_DOWNLOAD_LOADER
} = slice.actions;

export default slice.reducer;
